var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconModel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_265",
    "data-name": "Group 265",
    transform: "translate(-208 -5925.667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_264",
    "data-name": "Group 264"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_263",
    "data-name": "Group 263"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M235.7,5949.944a4.387,4.387,0,0,1-4.425-3.993,7.513,7.513,0,0,0,1.73-1.709,10.391,10.391,0,0,0,1.872-4.885.742.742,0,0,0,.188-.264,8.059,8.059,0,0,0,.625-3.137,7.357,7.357,0,0,0-7.056-7.61,6.553,6.553,0,0,0-2.937.7,5.152,5.152,0,0,0-1.038.186,5.836,5.836,0,0,0-3.662,3.337,8.284,8.284,0,0,0-.411,5.438,8.758,8.758,0,0,0,.38,1.152.749.749,0,0,0,.176.256,9.35,9.35,0,0,0,3.593,6.534,4.39,4.39,0,0,1-4.425,4,5.146,5.146,0,0,0-4.965,5.136v5.778a.749.749,0,0,0,.749.749h23.822a.749.749,0,0,0,.749-.749v-5.778A5.147,5.147,0,0,0,235.7,5949.944Zm-10.625-19.276a3.719,3.719,0,0,1,.857-.139.746.746,0,0,0,.315-.085,5.094,5.094,0,0,1,2.387-.6,5.861,5.861,0,0,1,5.558,6.112c0,.1,0,.2-.007.3a3.262,3.262,0,0,0-2.332-.979h-5.105a1.4,1.4,0,0,1-1.295-.875.918.918,0,0,0-1.74.115,6.939,6.939,0,0,1-1.695,3.033C221.26,5934.453,222.619,5931.376,225.07,5930.668Zm-.652,12.954a8.8,8.8,0,0,1-1.815-4.559,8.474,8.474,0,0,0,2.178-3.053,2.632,2.632,0,0,0,.233.193,2.868,2.868,0,0,0,1.729.574h5.105a1.778,1.778,0,0,1,1.622,1.053v.016c0,4.227-2.453,7.667-5.468,7.667A4.686,4.686,0,0,1,224.418,5943.622Zm1.721,3.059a5.444,5.444,0,0,0,3.723,0,5.86,5.86,0,0,0,2.178,3.531l-3.933,5.6a.123.123,0,0,1-.106.055.126.126,0,0,1-.106-.055l-3.933-5.6A5.87,5.87,0,0,0,226.139,5946.681Zm13.023,13.429H216.838v-5.029a3.647,3.647,0,0,1,3.643-3.643,6.414,6.414,0,0,0,2.185-.462l4,5.7a1.633,1.633,0,0,0,1.332.692h0a1.63,1.63,0,0,0,1.332-.692l4-5.7a6.17,6.17,0,0,0,2.183.461,3.647,3.647,0,0,1,3.643,3.643v5.029Z",
    fill: "#3d4463"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_165",
    "data-name": "Rectangle 165",
    width: 40,
    height: 40,
    transform: "translate(208 5925.667)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconModel);
export default __webpack_public_path__ + "static/media/icon-model.3d938d9a1ecbf6b72e4efe2a218e95d7.svg";
export { ForwardRef as ReactComponent };